module.exports = __webpack_public_path__ + "static/media/the_2.c21ebeb1.png";